import PageContainer from './container';

export default PageContainer;
